import { render, staticRenderFns } from "./DeleteBill.vue?vue&type=template&id=0737fa54&"
import script from "./DeleteBill.vue?vue&type=script&lang=js&"
export * from "./DeleteBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeleteBill.vue"
export default component.exports